import {
    ActionIcon,
    Box,
    Button,
    Code,
    CopyButton,
    Group,
    Modal,
    Text,
    TextInput,
    Tooltip,
} from '@mantine/core';
import {IconCheck, IconCopy} from '@tabler/icons-react';
import React, {useEffect, useState} from 'react';
import {UserService} from '../../client';

function generateRandomString(): string {
    let outString = '';
    const inOptions = 'abcdefghijklmnopqrstuvwxyz0123456789@!#&^';
    for (let i = 0; i < 16; i++) {
        outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
    }
    return outString;
}

type ChangePasswordModalProps = {
    opened: boolean;
    onClose: () => void;
    username: string;
};

export function ChangePasswordModal({opened, onClose, username}: ChangePasswordModalProps) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [suggestedPassword, setSuggestedPassword] = useState('');

    useEffect(() => {
        if (opened && username) {
            setSuggestedPassword(generateRandomString());
            setNewPassword('');
            setConfirmPassword('');
        }
    }, [opened, username]);

    const handleClose = () => {
        setNewPassword('');
        setConfirmPassword('');
        onClose();
    };

    const submitDisabled = newPassword === '' || confirmPassword !== newPassword;

    return (
        <Modal
            opened={opened}
            centered
            onClose={handleClose}
            title="Change password"
            transitionProps={{transition: 'rotate-left'}}
        >
            <Box>
                <Text mt={5}>Change password of {username}</Text>
                <Group m={5} ml={0} c="dimmed">
                    <Text mt={4}>Suggestion: </Text>
                    <Code>{suggestedPassword}</Code>
                    <CopyButton value={suggestedPassword} timeout={2000}>
                        {({copied, copy}) => (
                            <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                                <ActionIcon
                                    color={copied ? 'teal' : 'gray'}
                                    variant="subtle"
                                    onClick={copy}
                                >
                                    {copied ? <IconCheck size={16}/> : <IconCopy size={16}/>}
                                </ActionIcon>
                            </Tooltip>
                        )}
                    </CopyButton>
                </Group>

                <TextInput
                    label="New password"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.currentTarget.value)}
                />
                <TextInput
                    label="Confirm password"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.currentTarget.value)}
                />
                <Button
                    mt={10}
                    disabled={submitDisabled}
                    onClick={() => {
                        UserService.updatePasswordByUsernameApiV1UserPasswordUsernamePut({
                            username,
                            requestBody: {
                                username,
                                password: confirmPassword,
                            },
                        }).then(() => handleClose());
                    }}
                >
                    Change password
                </Button>
            </Box>
        </Modal>
    );
}
